/// flickity slider custom for section pdp logo
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Flickity === "undefined") {
    console.warn("Flickity CDN not loaded.");
    return;
  }

  const e = document.querySelector(".logo-slider");
  if (e) {
    const visibleLogos = 5;  
    
    const logoWidth = 100 / visibleLogos; 
    
   
    const cells = e.querySelectorAll(".slide");
    cells.forEach(cell => {
      cell.style.width = `${logoWidth}%`;
    });

  
    new Flickity(e, {
      autoPlay: 3000,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      groupCells: 1,   
      cellAlign: "left",
      
    });
  }
});

// js for rewards faq section 

jQuery(document).ready(function($) {
  $('.rewards-faq .toggle h5').on('click', function() {
    var $accordionContent = $(this).next();
    var $plusIcon = $(this).find('.plus-icon');
    var $minusIcon = $(this).find('.minus-icon');
    
    $('.rewards-faq .toggle p').slideUp();
    $('.rewards-faq .toggle h5').removeClass('open');
    $('.rewards-faq .toggle .plus-icon').show();
    $('.rewards-faq .toggle .minus-icon').hide();
    
    if ($accordionContent.is(':visible')) {
      $accordionContent.slideUp();
      $plusIcon.show();
      $minusIcon.hide();
    } else {
      $accordionContent.slideDown();
      $(this).addClass('open');
      $plusIcon.hide();
      $minusIcon.show();
    }
  });
});
